<div class="row gx-2 rab-layout" [ngClass]="layoutClass" *ngIf="!showGroupedBranchListbox">
  <span class="col-md-4" *ngIf="showRegion">
    <label class="form-label custom-form-label fw-bold">Region</label>
    <mdb-select
      class="crud-select-field"
      [required]="required"
      [visibleOptions]="8"
      [clearButton]="true"
      placeholder="Select region"
      [(ngModel)]="selectedRegion"
      (ngModelChange)="onRegionChange($event)">
      <mdb-option *ngFor="let region of regions" [value]="region">{{ region.name }}</mdb-option>
    </mdb-select>
  </span>

  <span class="col-md-4" *ngIf="showArea">
    <label class="form-label custom-form-label fw-bold">Area</label>
    <mdb-select
      class="crud-select-field"
      [required]="required"
      [disabled]="isAreaDisabled"
      [visibleOptions]="12"
      [clearButton]="true"
      placeholder="Select area"
      [(ngModel)]="selectedArea"
      (ngModelChange)="onAreaChange($event)">
      <mdb-option *ngFor="let area of areas" [value]="area">{{ area.name }}</mdb-option>
    </mdb-select>
  </span>

  <span class="col-md-4" *ngIf="showBranch">
    <label class="form-label custom-form-label fw-bold">Branch</label>
    <mdb-select
      class="crud-select-field"
      [required]="required"
      [disabled]="isBranchDisabled"
      [visibleOptions]="12"
      [clearButton]="true"
      placeholder="Select branch"
      [(ngModel)]="selectedBranch"
      (ngModelChange)="onBranchChange($event)">
      <mdb-option *ngFor="let branch of branches" [value]="branch">{{ branch.branchName }}</mdb-option>
    </mdb-select>
  </span>
</div>

<div class="row gx-2 rab-layout" [ngClass]="layoutClass" *ngIf="showGroupedBranchListbox">
  <div class="col-md-4" *ngIf="showRegion">
    <label class="form-label custom-form-label">Region</label>
    <mdb-select
      class="crud-select-field"
      [required]="required"
      [visibleOptions]="8"
      [clearButton]="true"
      placeholder="Select region"
      [(ngModel)]="selectedRegion"
      (ngModelChange)="onRegionChange($event)">
      <mdb-option *ngFor="let region of regions" [value]="region">{{ region.name }}</mdb-option>
    </mdb-select>
  </div>

  <div class="col-md-8">
    <label class="form-label custom-form-label">Branch</label>
    <mdb-select
      class="crud-select-field"
      [required]="required"
      [disabled]="isGroupedListboxDisabled"
      [visibleOptions]="12"
      [clearButton]="true"
      placeholder="Select branch"
      [(ngModel)]="selectedBranch"
      (ngModelChange)="onGroupedBranchChange($event)">
      <mdb-option-group *ngFor="let group of groupedBranchOptions" [label]="group.label">
        <mdb-option *ngFor="let branch of group.branches" [value]="branch">{{ branch.branchName }}</mdb-option>
      </mdb-option-group>
    </mdb-select>
  </div>
</div>
